<mat-card class="subform-card w-100">
  <mat-card-header>
    <mat-card-title class="subform-group-title">
      {{ title ?? "SHARED.LOCALIZED_SEO_SUBFORM.TITLE" | translate }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container [formGroup]="form">
      <!-- class="border" -->
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="30px"
        *ngFor="let key of getKeys(); let i = index"
      >
        <!-- <span class="padded-bottom"> {{ getNameByCode(key) | titlecase }}</span> -->

        <div [formGroupName]="key">
          <mat-form-field appearance="outline">
            <mat-label>
              {{ "SHARED.LOCALIZED_SEO_SUBFORM.FRIENDLY_URL" | translate }}
            </mat-label>
            <input
              matInput
              [placeholder]="
                'SHARED.LOCALIZED_SEO_SUBFORM.FRIENDLY_URL_PLACEHOLDER'
                  | translate
              "
              formControlName="friendlyUrl"
            />
            <mat-hint>{{
              "SHARED.LOCALIZED_SEO_SUBFORM.REQUIRED" | translate
            }}</mat-hint>
            <mat-error *ngIf="getServerError('friendlyUrl')">
              {{ getServerError("friendlyUrl") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>
              {{ "SHARED.LOCALIZED_SEO_SUBFORM.META_TITLE" | translate }}
            </mat-label>
            <input
              matInput
              [placeholder]="
                'SHARED.LOCALIZED_SEO_SUBFORM.META_TITLE_PLACEHOLDER'
                  | translate
              "
              formControlName="metaTitle"
            />
            <mat-hint>{{
              "SHARED.LOCALIZED_SEO_SUBFORM.REQUIRED" | translate
            }}</mat-hint>
            <mat-error *ngIf="getServerError('metaTitle')">
              {{ getServerError("metaTitle") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>
              {{ "SHARED.LOCALIZED_SEO_SUBFORM.META_DESCRIPTION" | translate }}
            </mat-label>
            <input
              matInput
              [placeholder]="
                'SHARED.LOCALIZED_SEO_SUBFORM.META_DESCRIPTION_PLACEHOLDER'
                  | translate
              "
              formControlName="metaDescription"
            />
            <mat-hint>{{
              "SHARED.LOCALIZED_SEO_SUBFORM.REQUIRED" | translate
            }}</mat-hint>
            <mat-error *ngIf="getServerError('metaDescription')">
              {{ getServerError("metaDescription") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" [formGroup]="metaInputs">
            <mat-label>
              {{ "SHARED.LOCALIZED_SEO_SUBFORM.META_TAGS" | translate }}
            </mat-label>
            <mat-chip-grid #chipList [formControlName]="key">
              <mat-chip-row
                *ngFor="let tag of metaTags[key]"
                class="easy-chip"
                [attr.aria-readonly]="readOnly"
                (removed)="removeTag(tag, key)"
              >
                {{ tag }}
                <button type="button" matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
              <input
                [placeholder]="
                  'SHARED.LOCALIZED_SEO_SUBFORM.META_TAGS_PLACEHOLDER'
                    | translate
                "
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addTag($event, key)"
                [matChipInputAddOnBlur]="true"
              />
            </mat-chip-grid>
            <mat-hint>
              {{ "SHARED.LOCALIZED_SEO_SUBFORM.REQUIRED" | translate }}
            </mat-hint>
            <mat-error *ngIf="getServerError(key)">
              {{ getServerError(key) }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
